import TagManager from 'react-gtm-module'

const gtmId = import.meta.env.VITE_GTM_ID

export default function (dataLayer) {
  if (!gtmId) return false

  const tagManagerArgs = {
    gtmId,
    dataLayer,
  }

  TagManager.initialize(tagManagerArgs)
  return true
}
